var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7047 16.0489H10.7376C7.39919 16.0489 5.72999 16.0489 4.69287 15.0118C4.11466 14.4336 3.85881 13.6589 3.7456 12.508M3.65576 8.96708V1",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31139 3.65576H8.96708C12.3055 3.65576 13.9747 3.65576 15.0118 4.69287C15.59 5.27109 15.8459 6.04579 15.9591 7.19669M1 3.65576H3.65569M16.0489 16.049V18.7047M16.0489 10.7376V13.3933",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropIcon);
export default __webpack_public_path__ + "static/media/crop_icon.2085ac92e5202306be858add8cfe535c.svg";
export { ForwardRef as ReactComponent };